module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst renderMode = ((storage || {}).request || {}).renderMode || ''\nlet footerLogoLeft\nif(utils.collectionSize(model.footerLogoLeft) > 0){\nfooterLogoLeft = helpers.detectRenderedImage(model.footerLogoLeft, model._footerLogoLeft)\n}\nlet footerLogoRight\nif(utils.collectionSize(model.footerLogoRight) > 0){\nfooterLogoRight = helpers.detectRenderedImage(model.footerLogoRight, model._footerLogoRight)\n}\n%><section class=\"footer\" style=\"padding-top: 10px; padding-bottom: 0; width: 100%; display: flex; flex-direction: column; color: lightgray; font-size: 10px; font-family: 'Open Sans', Arial, sans-serif;\"><%\n%><div class=\"main\" style=\"display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;\"><%\n%><div style=\"flex: 0 0 218px; text-align: right;\"><%\nif(footerLogoLeft){\n%><img style=\"max-width: 100%;\" src=\"<%= footerLogoLeft.rendered.url %>\" width=\"<%= footerLogoLeft.rendered.width %>\" height=\"<%= footerLogoLeft.rendered.height %>\" alt=\"<%= footerLogoLeft.alt || footerLogoLeft.title %>\"><%\n}\n%></div><%\n%><div style=\"flex: 1 1 auto; line-height: 1.25; font-size: 10px; color: lightgray;\">&nbsp;</div><%\n%><div style=\"flex: 0 0 218px; text-align: left;\"><%\nif(footerLogoRight){\n%><img style=\"max-width: 180px;\" src=\"<%= footerLogoRight.rendered.url %>\" width=\"<%= footerLogoRight.rendered.width %>\" height=\"<%= footerLogoRight.rendered.height %>\" alt=\"<%= footerLogoRight.alt || footerLogoRight.title %>\"><%\n}\n%></div><%\n%></div><%\nif(renderMode === 'html'){\n%><div style=\"text-align: right; margin: 0 68px 0 0; color: lightgray;\"><%\n%><%= storage.__('document.general.pageNumberPrefix') %> <span class=\"pageNumber\"></span> / <span class=\"totalPages\"></span><%\n%></div><%\n}\n%></section>"
  , __filename = "components/templates/core/documents/document/footer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const renderMode = ((storage || {}).request || {}).renderMode || ''
let footerLogoLeft
if(utils.collectionSize(model.footerLogoLeft) > 0){
footerLogoLeft = helpers.detectRenderedImage(model.footerLogoLeft, model._footerLogoLeft)
}
let footerLogoRight
if(utils.collectionSize(model.footerLogoRight) > 0){
footerLogoRight = helpers.detectRenderedImage(model.footerLogoRight, model._footerLogoRight)
}

    ; __line = 11
    ; __append("<section class=\"footer\" style=\"padding-top: 10px; padding-bottom: 0; width: 100%; display: flex; flex-direction: column; color: lightgray; font-size: 10px; font-family: 'Open Sans', Arial, sans-serif;\">")
    ; 

    ; __line = 12
    ; __append("<div class=\"main\" style=\"display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;\">")
    ; 

    ; __line = 13
    ; __append("<div style=\"flex: 0 0 218px; text-align: right;\">")
    ; 
if(footerLogoLeft){

    ; __line = 15
    ; __append("<img style=\"max-width: 100%;\" src=\"")
    ; __append(escapeFn( footerLogoLeft.rendered.url ))
    ; __append("\" width=\"")
    ; __append(escapeFn( footerLogoLeft.rendered.width ))
    ; __append("\" height=\"")
    ; __append(escapeFn( footerLogoLeft.rendered.height ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( footerLogoLeft.alt || footerLogoLeft.title ))
    ; __append("\">")
    ; 
}

    ; __line = 17
    ; __append("</div>")
    ; 

    ; __line = 18
    ; __append("<div style=\"flex: 1 1 auto; line-height: 1.25; font-size: 10px; color: lightgray;\">&nbsp;</div>")
    ; 

    ; __line = 19
    ; __append("<div style=\"flex: 0 0 218px; text-align: left;\">")
    ; 
if(footerLogoRight){

    ; __line = 21
    ; __append("<img style=\"max-width: 180px;\" src=\"")
    ; __append(escapeFn( footerLogoRight.rendered.url ))
    ; __append("\" width=\"")
    ; __append(escapeFn( footerLogoRight.rendered.width ))
    ; __append("\" height=\"")
    ; __append(escapeFn( footerLogoRight.rendered.height ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( footerLogoRight.alt || footerLogoRight.title ))
    ; __append("\">")
    ; 
}

    ; __line = 23
    ; __append("</div>")
    ; 

    ; __line = 24
    ; __append("</div>")
    ; 
if(renderMode === 'html'){

    ; __line = 26
    ; __append("<div style=\"text-align: right; margin: 0 68px 0 0; color: lightgray;\">")
    ; 

    ; __line = 27
    ; __append(escapeFn( storage.__('document.general.pageNumberPrefix') ))
    ; __append(" <span class=\"pageNumber\"></span> / <span class=\"totalPages\"></span>")
    ; 

    ; __line = 28
    ; __append("</div>")
    ; 
}

    ; __line = 30
    ; __append("</section>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/document/footer.ejs

}